/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Learn_RisksInputs */

const en_learn_risks = /** @type {(inputs: Learn_RisksInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`[Risks](/risks). A summary of the risks of AI.`)
};

/**
* | output |
* | --- |
* | "[Risks](/risks). A summary of the risks of AI." |
*
* @param {Learn_RisksInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const learn_risks = /** @type {((inputs?: Learn_RisksInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Learn_RisksInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_learn_risks(inputs)
});